module.exports = __webpack_public_path__ + "static/media/product.d2599316.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupCards/assets/product.png
// module id = 532
// module chunks = 0